import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './TabNav.css';
import style from './TabNav.module.css'
import Translator from '../I18n/Translator';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { yellow } from '@mui/material/colors';
import { LinguagemContext } from '../../common/context/LinguagemContext';
import { ServerContext } from '../../common/context/ServerContext';
import {format} from 'date-fns';
import { UsuarioContext } from '../../common/context/UsuarioContext';
import { use } from 'react';

//receba por parametros theme=theme link_gripe="" link_zika= ""
const TabNav = ({theme, currentPage, link_gripe, link_zika, url_atual}) => {

    const { t } = useTranslation();

    const {navigate} = useNavigate();
    
    const {language} = useContext(LinguagemContext);

    const {servidor} = useContext(ServerContext);
    
    const {logado, setLogado} = useContext(UsuarioContext);

    const rectangleCount = 10; // Número de retângulos
    /*const redTones = [
        "#990000",
        "#CC0000",
        "#FF0000",
        "#FF3333",
        "#FF6666",
        "#FF9999",
        "#FFCCCC",
        "#FF9999",
        "#FF6666",
        "#FF3333"
    ];*/

    const redTones = [
        "#FFCCCC",
        "#FF9999",
        "#FF9999",
        "#FF6666",
        "#FF6666",
        "#FF3333",
        "#FF3333",
        "#FF0000",
        "#CC0000",
        "#990000"
    ];

    const rectangles = [];
    for (let i = 0; i < rectangleCount; i++) {
        const style = {
            backgroundColor: redTones[i],
            maxHeight: "5px",
            minHeight: "2px",
            maxWidth: "10%",
            minWidth: "10%",
            flex: "1"
        };
        rectangles.push(<div key={i} style={style}></div>);
    }

    const pages = {
        "Painel Completo": "/mapa",
        "Metagenomica": "/metagenomic",
        "IBP": "/ibp",
        "Clima": "/climate",
        /*"Web Based": "/webbased"*/
    };

    const pages_translated = {
        "Painel Completo": "links_menu.mapa",
        "Metagenomica": "links_menu.metagenomic",
        "IBP": "links_menu.ibp",
        "Clima": "links_menu.climate",
        /*"Web Based": "links_menu.webbased"*/
    };

    const corDesativado = "rgba(196, 126, 126, 1)";
    const corAtivado = "#990000";
    const [isResumido, setIsResumido] = useState(true);;

    let [openMenu, setOpenMenu] = useState(false)
    const handleMenu = () => {
        setOpenMenu(prevOpenMenu => !prevOpenMenu);
        console.log(openMenu)
    }

    useEffect(() => {
        setIsResumido(currentPage === "Painel Resumido");
    }, []);
    /*const currentPage_ = url_atual === "/maparesumido" ? "Painel Completo" : currentPage;*/

    /*return (
        <div>
            <div className='nav_abas' style={{backgroundColor: theme === "dark" ? "black" : "white"}}>
                <div className='linha_sup_menu'>
                    <div className="menu">
                        <button href="#" className="menu-button"><Translator path="dashboard.gripe" /></button> 
                    </div>   
                    <div className="menu2">
                        <a href={link_zika} style={{ textDecoration: 'none' }}>
                            <button className="menu-button2" style={{backgroundColor: theme === "dark" ? "#363636" : "#d6d6d6"}}><Translator path="dashboard.arbo" /> <img className="arrow ocultar" src="imagens/seta-para-expandir.png"/></button>
                        </a>
                    </div>
                    <div className='div_help'>
                        <a href={language === "pt" ? "Dados/help.pdf" : "Dados/help_ingles.pdf"}  target='_blank' rel='noopener noreferre'>
                            <img src="imagens/icones/informacoes.png" className='img_help' alt="Help Icon"/>
                        </a>
                    </div>
                </div>
                <div style={{minHeight: "5px", minWidth:"100%", display:"flex"}}>{rectangles}</div> 
                <div className="menu3" style={{backgroundColor: !isResumido ? corAtivado : corDesativado}}>
                    <Link to={isResumido ? "/mapa" : "#"} style={{ textDecoration: 'none' }}>
                        <button href={isResumido ? "/mapa" : "#"} className={!isResumido ? "submenu-button active_button" : "submenu-button deactive_button"} >{isResumido ? t(pages_translated["Painel Completo"]) : t(pages_translated[currentPage])}<img class="arrow" src="imagens/seta-para-expandir.png"/></button>
                    </Link>
                    <div className="submenu">
                        {Object.entries(pages)
                            .filter(([name]) => (name !== (isResumido ? "Painel Completo" : currentPage)) ) // Exclui a página atual
                            .map(([name, path]) => (
                                
                                  <Link 
                                        to={path}
                                        style={{ 
                                        textDecoration: 'none', 
                                     
                                        color: 'white',
                                        display: 'block', 
                                        width: '100%', 
                                        height: '100%' 
                                        }}
                                    >{t(pages_translated[name])}</Link>
                            ))}
                        
                    </div>   
                </div> 
                <div className="menu4" style={{backgroundColor: isResumido ? corAtivado : corDesativado}}>
                    <Link to="/maparesumido" style={{ textDecoration: 'none'}}> 
                        <button className={isResumido ? "submenu4-button active_button" : "submenu4-button deactive_button"}>{t("links_menu.mapa_resumido")}</button> 
                    </Link>
                </div> 
                
            </div> 

            <div className='space_nav_abas_'></div> 
        </div>
    );*/
    return (
        <div>
            <div className='nav_abas' style={{backgroundColor: theme === "dark" ? "black" : "white"}}>
                <div className='linha_sup_menu'>
                    <div className="menu">
                        <button href="#" className="menu-button"><Translator path="dashboard.gripe" /></button> 
                    </div>   
                    <div className="menu2">
                        <a href={link_zika} style={{ textDecoration: 'none' }}>
                            <button className="menu-button2" style={{backgroundColor: theme === "dark" ? "#363636" : "#d6d6d6"}}><Translator path="dashboard.arbo" /> <img className="arrow ocultar" src="/flu/imagens/seta-para-expandir.png"/></button>
                        </a>
                    </div>
                    <div className='div_help'>
                        <div className="tooltip-help">
                            <p><Translator path="help.icon" /></p>
                        </div>
                        <a href="/flu/help"  target='_blank' rel='noopener noreferre'>
                            <img src="/flu/imagens/balao_ajuda.png" className='img_help' alt="Help Icon"/>
                        </a>
                    </div>
                </div>
                <div style={{minHeight: "5px", minWidth:"100%", display:"flex"}}>{rectangles}</div> 
                <div className="menu3" style={{backgroundColor: corAtivado }}>
                   
                    <div className="menu4" style={{backgroundColor: isResumido ? corAtivado : corDesativado}}>
                        <Link to="/maparesumido" style={{ textDecoration: 'none'}}> 
                            <button className={isResumido ? "submenu4-button active_button" : "submenu4-button deactive_button"} style={{backgroundColor: isResumido ? corAtivado : corDesativado}}>{t("links_menu.mapa_resumido")}</button> 
                        </Link>
                    </div>  
                     <div style={{backgroundColor: !isResumido ? corAtivado : corDesativado, position: "relative", display: "flex"}}>
                        <Link to="/mapa" onMouseEnter={() => {setOpenMenu(true)}} onMouseLeave={() => setOpenMenu(false)} className={openMenu ? "active-menu" : "desactive-menu"} style={{ textDecoration: 'none', backgroundColor: !isResumido ? corAtivado : corDesativado }}>
                            <button href={isResumido ? "flu/mapa" : "#"} className={!isResumido ? "submenu-button active_button" : "submenu-button deactive_button"} style={{ textDecoration: 'none', backgroundColor: !isResumido ? corAtivado : corDesativado }}>{isResumido ? t(pages_translated["Painel Completo"]) : t(pages_translated[currentPage])}<img className="arrow" src="/flu/imagens/seta-para-expandir.png"/></button>
                        </Link>
                        <div onMouseEnter={() => {setOpenMenu(true)}} onMouseLeave={() => setOpenMenu(false)} className={openMenu ? "submenu active-menu" : "submenu-close"}>
                            {/*Object.entries(pages)
                                .filter(([name]) => (name !== (isResumido ? "Painel Completo" : currentPage)) ) // Exclui a página atual
                                .map(([name, path]) => (
                                    <a href={path} onMouseEnter={() => {setOpenMenu(true)}} key={name}>{t(pages_translated[name])}</a>
                                ))*/} 
                                {Object.entries(pages)
                                .filter(([name]) => name !== (isResumido ? "Painel Completo" : currentPage)) // exclui a página atual
                                .map(([name, path]) => (
                                    <Link
                                    key={name}
                                    to={path}
                                    onMouseEnter={() => setOpenMenu(true)}
                                    style={{
                                        textDecoration: "none",
                                        //color: "inherit",
                                        //marginRight: "1rem" // opcional: espaço entre links
                                    }}
                                    >
                                    {t(pages_translated[name])}
                                    </Link>
                                ))}
                            
                        </div>  
                    </div>
                </div> 
                
            </div> 

            <div className='space_nav_abas_'>{isResumido}</div> 
        </div>
    );
};

export default TabNav;